/**
 * 처방 판정 테스트 패널 — styled(설계 결정 14: 용량 룰 검수 화면의 styled 관행을 따른다).
 * 보조 텍스트 색은 Gray[500], 코드 표시 12px, 사유·안내·약품 수준 줄 13px(§6.1-7).
 *
 * 결과 카드·원문 뷰가 쓰던 styled(Card·InfoLine·Row·WarnText 등 18개)는
 * organism DoseReviewResultView/style.ts로 승격됐다(@spec:2026-09-29-처방검토-판정기록-조회화면).
 * 패널 본문은 공용 4개(Card·InfoLine·Row·WarnText)를 그 organism style에서 import한다.
 */
import styled from "styled-components";
import { COLOR_SYSTEM } from "components/design/design-system";

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: ${COLOR_SYSTEM.get("Gray")?.[900]};
`;

export const PanelTitle = styled.h2`
  font-size: 18px;
  font-weight: 700;
  margin: 0;
  color: ${COLOR_SYSTEM.get("Gray")?.[900]};
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SectionTitle = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: ${COLOR_SYSTEM.get("Gray")?.[700]};
`;

export const Field = styled.label`
  display: inline-flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  color: ${COLOR_SYSTEM.get("Gray")?.[500]};
`;

export const NumberInput = styled.input`
  height: 36px;
  width: 120px;
  padding: 0 10px;
  border: 1px solid ${COLOR_SYSTEM.get("Gray")?.[100]};
  border-radius: 8px;
  font-size: 14px;
  color: ${COLOR_SYSTEM.get("Gray")?.[800]};
  &:disabled {
    background-color: ${COLOR_SYSTEM.get("Gray")?.[50]};
  }
`;

export const PresetNote = styled.div`
  font-size: 12px;
  color: ${COLOR_SYSTEM.get("Gray")?.[500]};
`;

export const PresetSelect = styled.select`
  height: 36px;
  max-width: 520px;
  padding: 0 10px;
  border: 1px solid ${COLOR_SYSTEM.get("Gray")?.[100]};
  border-radius: 8px;
  background-color: ${COLOR_SYSTEM.get("Gray")?.[0]};
  color: ${COLOR_SYSTEM.get("Gray")?.[800]};
  font-size: 14px;
`;

export const Table = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const HeaderRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 110px 110px 40px;
  gap: 8px;
  font-size: 12px;
  font-weight: 700;
  color: ${COLOR_SYSTEM.get("Gray")?.[500]};
`;

export const DrugRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 110px 110px 40px;
  gap: 8px;
  align-items: start;
`;

export const CellInput = styled.input`
  height: 36px;
  width: 100%;
  padding: 0 10px;
  border: 1px solid ${COLOR_SYSTEM.get("Gray")?.[100]};
  border-radius: 8px;
  font-size: 14px;
  color: ${COLOR_SYSTEM.get("Gray")?.[800]};
  &:disabled {
    background-color: ${COLOR_SYSTEM.get("Gray")?.[50]};
  }
`;

export const CodeText = styled.div`
  font-size: 12px;
  color: ${COLOR_SYSTEM.get("Gray")?.[500]};
  margin-top: 4px;
`;

export const ResultSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-top: 1px solid ${COLOR_SYSTEM.get("Gray")?.[100]};
  padding-top: 12px;
`;

export const ResultHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const ChangedBanner = styled.div`
  font-size: 13px;
  color: ${COLOR_SYSTEM.get("Orange")?.[600] ?? COLOR_SYSTEM.get("Red")?.[400]};
  background-color: ${COLOR_SYSTEM.get("Yellow")?.[10]};
  border: 1px solid ${COLOR_SYSTEM.get("Yellow")?.[100]};
  border-radius: 8px;
  padding: 8px 10px;
`;

export const EmptyText = styled.div`
  font-size: 13px;
  color: ${COLOR_SYSTEM.get("Gray")?.[500]};
  padding: 24px 0;
  text-align: center;
`;
